module.exports = __webpack_public_path__ + "01_short_black.1a2b9364.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/01_short_black.png
// module id = 69rn
// module chunks = 0